import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ExaminationService {
  httpOptions: any;
  headers: any;
  user: any = 'shinto';
  isIEOrEdge: any = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)

  private _refreshNeeded$ = new Subject<void>();
  private messageSource = new BehaviorSubject('messageData');
  currentMessage = this.messageSource.asObservable();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }


  constructor(private http: HttpClient) {

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'shintoonlne',
        'UserName': this.user,
        'Browser': this.isIEOrEdge
      })
    };
  }

  getAllTempExam(url) {
    return this.http.get(url, this.httpOptions)
  }

  getResultByEnrollmentNo(url, param) {
    return this.http.post(url, param, this.httpOptions)
  }

  getExamByParam(url, param) {
    return this.http.post(url, param, this.httpOptions)
  }

  postExamMarks(url, param) {
    return this.http.post(url, param, this.httpOptions)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }

  deleteExamByID(url, param) {
    return this.http.put(url, param, this.httpOptions)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }

  changeMessage(message: any) {
    this.messageSource.next(message);

  }

  TrasferTempExams(url) {
    return this.http.get(url, this.httpOptions)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }
}

